var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20 / Close-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2427 5.75739L10.0001 10M10.0001 10L5.75739 14.2427M10.0001 10L14.2427 14.2426M10.0001 10L5.75739 5.75733",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#47506A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.40eb1c019a60018e297c984fd82e38c0.svg";
export { ForwardRef as ReactComponent };